"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandThemeProvider = exports.currentBrandTheme = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const getFloraTheme_1 = require("../../utils/getFloraTheme");
exports.currentBrandTheme = (0, getFloraTheme_1.getFloraThemeByBrand)();
/**
 * Provider do tema do Flora, já levando em conta a marca "boticário", "oui", etc.
 */
const BrandThemeProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.FloraProvider, Object.assign({ theme: exports.currentBrandTheme, resetCSS: true }, props, { children: children })));
};
exports.BrandThemeProvider = BrandThemeProvider;
